// use esversion: 6
import React, { Component } from "react";

class Logo extends Component {
  render() {
    return (
      <svg
        id="CPL-Logo"
        className={this.props.className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 81 87">
        <g fill={this.props.fill}>
          <path
            className="st2"
            d="M29.1 45.2l-8.6 8.6-.1.1c-5.2 5.2-5.1 13.7.2 19 5.3 5.3 13.8 5.4 19 .2l.1-.1 8.6-8.6h-.1c-5.2 4.2-13 3.8-18-1.2-4.8-4.9-5.3-12.7-1.1-18z"
          />
          <path
            className="st3"
            d="M36.4 35.4l-8.6-8.6-.1-.1c-5.2-5.2-13.7-5.1-19 .2-5.3 5.3-5.4 13.8-.2 19 0 0 0 .1.1.1l8.6 8.6.1-.1c-4.2-5.2-3.8-13 1.2-18 4.8-4.8 12.6-5.3 17.9-1.1z"
          />
          <path
            className="st4"
            d="M48.7 43.5l8.5-8.6.1-.1c5.2-5.2 5.1-13.7-.3-19-5.3-5.3-13.8-5.4-19-.2l-.1.1-8.6 8.6.1.1c5.2-4.2 13-3.8 18 1.2 4.9 4.8 5.4 12.6 1.3 17.9z"
          />
          <path
            className="st5"
            d="M42.1 54.2l8.6 8.6.1.1c5.2 5.2 13.7 5.1 19-.3 5.3-5.3 5.4-13.8.2-19 0 0 0-.1-.1-.1l-8.6-8.6-.1.1c4.2 5.2 3.8 13-1.2 18-4.8 4.9-12.6 5.3-17.9 1.2z"
          />
        </g>
      </svg>
    );
  }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/appBar/Logo.js